import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { useRetailerRoutingContext } from "@faire/retailer/RetailerRoutingContextProvider";
import { IMAGES, KEYWORDS, getURLFromKeyword } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/consts";
var convertToOptimizedImage = function(url, isSSR, width, height) {
    var _optimizeImageUrlFillRectangle;
    return (_optimizeImageUrlFillRectangle = optimizeImageUrlFillRectangle(IImage.build({
        url: url
    }), isSSR, width, height)) !== null && _optimizeImageUrlFillRectangle !== void 0 ? _optimizeImageUrlFillRectangle : "";
};
export var useGetBottomSignUpBannerImages = function() {
    var isSSR = useIsSSR();
    return IMAGES().map(function(currentVariant) {
        var imageUrls = currentVariant.imageUrls, keyword = currentVariant.keyword;
        var _imageUrls = _sliced_to_array(imageUrls, 4), image0 = _imageUrls[0], image1 = _imageUrls[1], image2 = _imageUrls[2], image3 = _imageUrls[3];
        var _$IMAGES = [
            {
                src: convertToOptimizedImage(image0, isSSR, 213, 273),
                zIndex: 2,
                dimensions: {
                    xlarge: {
                        height: "273px",
                        top: "0",
                        left: "10%"
                    },
                    desktop: {
                        height: "258px",
                        top: "0",
                        left: "10%"
                    },
                    tablet: {
                        height: "176px",
                        top: "0",
                        left: "7%"
                    },
                    mobile: {
                        height: "0",
                        top: "0",
                        left: "0"
                    }
                }
            },
            {
                src: convertToOptimizedImage(image1, isSSR, 341, 225),
                zIndex: 1,
                dimensions: {
                    xlarge: {
                        height: "225px",
                        bottom: "7%",
                        left: "0"
                    },
                    desktop: {
                        height: "212px",
                        bottom: "7%",
                        left: "0"
                    },
                    tablet: {
                        height: "145px",
                        bottom: "7%",
                        left: "0"
                    },
                    mobile: {
                        height: "0",
                        bottom: "0",
                        left: "0"
                    }
                }
            },
            {
                src: convertToOptimizedImage(image2, isSSR, 290, 330),
                zIndex: 1,
                dimensions: {
                    xlarge: {
                        height: "330px",
                        top: "88px",
                        right: "0"
                    },
                    desktop: {
                        height: "311px",
                        top: "88px",
                        right: "0"
                    },
                    tablet: {
                        height: "212px",
                        top: "88px",
                        right: "0"
                    },
                    mobile: {
                        height: "265px",
                        top: "0",
                        right: "0"
                    }
                }
            },
            {
                src: convertToOptimizedImage(image3, isSSR, 207, 232),
                zIndex: 1,
                dimensions: {
                    xlarge: {
                        height: "232px",
                        bottom: "5%",
                        right: "167px"
                    },
                    desktop: {
                        height: "219px",
                        bottom: "3%",
                        right: "111px"
                    },
                    tablet: {
                        height: "150px",
                        bottom: "5%",
                        right: "102px"
                    },
                    mobile: {
                        height: "168px",
                        bottom: "0",
                        left: "0"
                    }
                }
            }
        ];
        return {
            keyword: keyword,
            images: _$IMAGES
        };
    });
};
export var useGetBottomSignUpBannerUrls = function() {
    var routingContext = useRetailerRoutingContext();
    return Object.values(KEYWORDS).map(function(keyword) {
        return {
            keyword: keyword,
            url: getURLFromKeyword(keyword, routingContext)
        };
    });
};
